var XMarkVariants;
(function (XMarkVariants) {
    XMarkVariants["DEEP_BLUE"] = "deepBlue";
    XMarkVariants["ULTRA_GREEN"] = "ultraGreen";
    XMarkVariants["BOLDY_BLUE"] = "boldyBlue";
    XMarkVariants["VERY_YELLOW"] = "veryYellow";
    XMarkVariants["CONFIDENTLY_CORAL"] = "confidentlyCoral";
    XMarkVariants["WHITE"] = "white";
})(XMarkVariants || (XMarkVariants = {}));
var XMarkStyles;
(function (XMarkStyles) {
    XMarkStyles["OUTLINED"] = "outlined";
    XMarkStyles["FILLED"] = "filled";
})(XMarkStyles || (XMarkStyles = {}));
export { XMarkVariants, XMarkStyles };
//# sourceMappingURL=XMark.types.js.map